export default {
  contacts: `profile/contact`,
  update: `profile/contact/update`,
  remove: `profile/contact/remove`,
};
